<template>
  <v-card elevation="1">
    <v-container
        style="max-width: unset"
        class="pa-4 pt-2 ma-0"
    >
      <v-row cols="12">
        <v-col cols="12" xs="12" sm="6" md="6" lg="3" xl="3">
          <label>Selecione a revenda</label>
          <v-autocomplete
              v-model="filter.resaleId"
              clearable
              :items="resales"
              item-text="name"
              item-value="id"
              append-icon="mdi-chevron-down"
              outlined
              label="Revenda"
              class="secondary-input"
              height="40px"
              dense
              hide-details
              @change="getSales()"
          >
            <template v-slot:item="{ item }">
              <span style="font-size: 13px">{{ item.name }}</span>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" lg="3" xl="3">
          <label>Selecione o estado</label>
          <v-autocomplete
              hide-details
              outlined
              class="secondary-input"
              placeholder="Estado"
              append-icon="mdi-chevron-down"
              v-model="filter.state"
              :items="states"
              item-text="nome"
              item-value="sigla"
              dense
              clearable
              @change="getSales()"
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="6" lg="3" xl="3">
          <label>Selecione a data de início</label>
          <v-text-field
              class="primary-input"
              hide-details
              outlined
              v-model="filter.startDate"
              dense
              clearable
              type="date"
              @input="getSales()"
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="6" lg="3" xl="3">
          <label>Selecione a data de fim</label>
          <v-text-field
              class="primary-input"
              hide-details
              outlined
              v-model="filter.endDate"
              dense
              clearable
              type="date"
              @input="getSales()"
          >
          </v-text-field>
        </v-col>
      </v-row>

      <v-row cols="12">
        <v-col cols="12" xs="12" sm="6" md="4" lg="3" xl="3">
          <div class="card-red">
            <h3>Receita Total</h3>
            <p>{{ formatCurrency(totalRevenue) }}</p>
          </div>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" lg="3" xl="3">
          <div class="card-black">
            <h3>Produtos Negociados</h3>
            <p>{{ negotiatedProducts }}</p>
          </div>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" lg="3" xl="3">
          <div class="card-black">
            <h3>Pedidos Realizados</h3>
            <p>{{ ordersPlaced }}</p>
          </div>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" lg="3" xl="3">
          <div class="card-black">
            <h3>Total de Metros/Un</h3>
            <p>{{ totalMetersUnit }}</p>
          </div>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" lg="3" xl="3">
          <div class="card-red">
            <h3>Ticket Médio</h3>
            <p>{{ formatCurrency(averageTicket) }}</p>
          </div>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" lg="3" xl="3">
          <div class="card-red">
            <h3>Descontos Concedidos</h3>
            <p>{{ formatCurrency(discountsGranted) }}</p>
          </div>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" lg="3" xl="3">
          <div class="card-black">
            <h3>Sellers Ativos</h3>
            <p>{{ activeSellers }}</p>
          </div>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" lg="3" xl="3">
          <div class="card-black">
            <h3>Clientes Cadastrados</h3>
            <p>{{ registeredCustomers }}</p>
          </div>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" lg="3" xl="3">
          <div class="card-black">
            <h3>Aplicadores Cadastrados</h3>
            <p>{{ registeredApplicators }}</p>
          </div>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" lg="3" xl="3">
          <div class="card-red">
            <h3>Investimento em Ads</h3>
            <p>{{ adsInvestment }}</p>
          </div>
        </v-col>
      </v-row>

      <v-row col="12">
        <v-col cols="12" xs="12" sm="12" md="12" lg="8" xl="8">
          <div id="chartRecipeAndOrder"></div>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
          <div id="chartPaymentMethod"></div>
        </v-col>
      </v-row>

      <v-row col="12">
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <table>
            <thead>
            <tr>
              <th>#</th>
              <th>Produto</th>
              <th>Receita do Produto</th>
              <th>Metros/UN</th>
            </tr>
            </thead>
            <tbody>

            <tr
                v-for="(bestSellingProduct, index) in bestSellingProducts"
                :key="bestSellingProduct.productId"
                @click="selectProduct(bestSellingProduct)"
                :style="bestSellingProductSelected && bestSellingProductSelected.productId
                  ? bestSellingProductSelected && bestSellingProductSelected.productId != bestSellingProduct.productId ? 'opacity: .3' : ''
                  : ''"
            >
              <td>{{ index + 1 }}.</td>
              <td>{{ bestSellingProduct.productName }}</td>
              <td class="receita">{{ formatCurrency(bestSellingProduct.salesValue) }}</td>
              <td class="metros">{{ bestSellingProduct.totalMetersUnit }}</td>
            </tr>
            </tbody>
          </table>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import formatCurrency from "../../../../Utils/FormatCurrency";
import Utils from "../../../../Utils/FormatCurrency";

export default {
  name: "Summary",
  computed: {},

  props: {},

  created() {
  },

  async mounted() {
    await this.getSales()
    await this.getResales()
  },
  data() {
    return {
      chartPaymentMethod: null,
      chartRecipeAndOrder: null,
      bestSellingProductSelected: Object,
      totalRevenue: 0,
      negotiatedProducts: 0,
      ordersPlaced: 0,
      totalMetersUnit: 0,
      averageTicket: 0,
      discountsGranted: 0,
      activeSellers: 0,
      registeredCustomers: 0,
      registeredApplicators: 0,
      adsInvestment: 0,
      resales: [],
      status: [],
      paymentMethods: [],
      bestSellingProducts: [],
      apiService: new ApiService(),
      states: [
        {sigla: 'AC', nome: 'Acre'},
        {sigla: 'AL', nome: 'Alagoas'},
        {sigla: 'AP', nome: 'Amapá'},
        {sigla: 'AM', nome: 'Amazonas'},
        {sigla: 'BA', nome: 'Bahia'},
        {sigla: 'CE', nome: 'Ceará'},
        {sigla: 'DF', nome: 'Distrito Federal'},
        {sigla: 'ES', nome: 'Espírito Santo'},
        {sigla: 'GO', nome: 'Goiás'},
        {sigla: 'MA', nome: 'Maranhão'},
        {sigla: 'MT', nome: 'Mato Grosso'},
        {sigla: 'MS', nome: 'Mato Grosso do Sul'},
        {sigla: 'MG', nome: 'Minas Gerais'},
        {sigla: 'PA', nome: 'Pará'},
        {sigla: 'PB', nome: 'Paraíba'},
        {sigla: 'PR', nome: 'Paraná'},
        {sigla: 'PE', nome: 'Pernambuco'},
        {sigla: 'PI', nome: 'Piauí'},
        {sigla: 'RJ', nome: 'Rio de Janeiro'},
        {sigla: 'RN', nome: 'Rio Grande do Norte'},
        {sigla: 'RS', nome: 'Rio Grande do Sul'},
        {sigla: 'RO', nome: 'Rondônia'},
        {sigla: 'RR', nome: 'Roraima'},
        {sigla: 'SC', nome: 'Santa Catarina'},
        {sigla: 'SP', nome: 'São Paulo'},
        {sigla: 'SE', nome: 'Sergipe'},
        {sigla: 'TO', nome: 'Tocantins'}
      ],
      filter: {
        page: 1,
        resaleId: null,
        productId: null,
        state: null,
        startDate: null,
        endDate: null,
      },
    };
  },
  methods: {
    renderChartOrderByStatus() {
      if (this.chartRecipeAndOrder) {
        this.chartRecipeAndOrder.destroy();
      }
      const sortedStatus = [...this.status].sort(
          (x, y) => y.salesValue - x.salesValue
      );

      const options = {
        chart: {
          height: 350,
          type: 'line',
          toolbar: {
            show: false
          },
        },
        series: [
          {
            name: "Receita",
            type: "line",
            data: sortedStatus.map(x => x.salesValue)
          },
          {
            name: "Pedido",
            type: "bar",
            data: sortedStatus.map(x => x.salesCount)
          }
        ],
        markers: {
          size: [6, 0], // Receita com bolinha (tamanho 6), Pedidos sem
          strokeColors: '#fff',
          strokeWidth: 2,
          hover: {size: 8}
        },
        xaxis: {
          categories: sortedStatus.map(x => x.description)
        },
        yaxis: [
          {
            title: {text: "Receita"},
            labels: {
              formatter: function (val) {
                return "R$ " + val.toLocaleString("pt-BR", {maximumFractionDigits: 0});
              }
            }
          },
          {
            opposite: true,
            title: {text: "Pedidos"},
            labels: {
              formatter: function (val) {
                return val;
              }
            }
          }
        ],
        colors: ["#b71c1c", "#00bcd4"],
        tooltip: {
          shared: true,
          intersect: false,
          y: [
            {
              formatter: function (val) {
                return "R$ " + val.toLocaleString("pt-BR", {minimumFractionDigits: 2});
              }
            },
            {
              formatter: function (val) {
                return val.toLocaleString("pt-BR") + " pedidos";
              }
            }
          ]
        },
        stroke: {
          width: [3, 0]
        },
        plotOptions: {
          bar: {
            columnWidth: "40%"
          }
        }
      };
      this.chartRecipeAndOrder = new ApexCharts(document.querySelector("#chartRecipeAndOrder"), options);
      this.chartRecipeAndOrder.render();
    },

    renderChartPaymentMethod() {
      if (this.chartPaymentMethod) {
        this.chartPaymentMethod.destroy();
      }
      const sortedPaymentMethods = [...this.paymentMethods].sort(
          (x, y) => y.salesValue - x.salesValue
      );
      const options = {
        chart: {
          type: 'pie',
          height: 350,
          toolbar: {show: false}
        },
        series: sortedPaymentMethods.map(x => x.salesValue), // valores em %
        labels: sortedPaymentMethods.map(x => x.description),
        colors: ['#b71c1c', '#00acc1', '#ffa000'],
        legend: {position: 'right'},
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            // mostra só a % dentro da fatia (ex: 58,7%)
            return val.toFixed(1).replace('.', ',') + '%';
          },
          style: {
            fontSize: '16px',
            fontWeight: '600',
            colors: ['#fff']
          },
          dropShadow: {enabled: true}
        },
        tooltip: {
          enabled: true,
          shared: false,
          followCursor: false,
          marker: {show: false}, // remove bolinha padrão
          custom: function ({series, seriesIndex, w}) {
            const value = series[seriesIndex] || 0;
            const total = series.reduce((a, b) => a + b, 0) || 1;
            const percent = ((value / total) * 100).toFixed(1).replace('.', ',');
            const valorBRL = value.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            });
            const color = w.config.colors[seriesIndex] || '#000';
            const label = w.config.labels[seriesIndex] || '';

            return `
        <div style="padding:10px 12px; border-radius:6px; background:#111; color:#fff; box-shadow:0 6px 18px rgba(0,0,0,0.2); font-family:inherit; min-width:160px;">
          <div style="display:flex; align-items:center; gap:8px; margin-bottom:6px;">
            <span style="width:10px; height:10px; border-radius:50%; background:${color}; display:inline-block;"></span>
            <span style="font-weight:600;">${label}</span>
          </div>
          <div style="font-weight:700; font-size:13px;">${valorBRL} <span style="font-weight:400; color:#ddd;">(${percent}%)</span></div>
        </div>
      `;
          }
        }
      };
      this.chartPaymentMethod = new ApexCharts(document.querySelector("#chartPaymentMethod"), options);
      this.chartPaymentMethod.render();
    },

    formatCurrency(value) {
      return Utils.formatCurrency(value);
    },

    getResales() {
      this.apiService.get("resale/list").then((response) => {
        this.resales = response;
      });
    },

    async selectProduct(bestSellingProduct) {
      if (this.bestSellingProductSelected.productId == bestSellingProduct.productId) {
        this.bestSellingProductSelected = Object
        this.filter.productId = null
      } else {
        this.bestSellingProductSelected = bestSellingProduct
        this.filter.productId = this.bestSellingProductSelected.productId
      }
      await this.getSales()
    },

    async getSales() {
      try {
        const {content} = await this.apiService.post("dashboard/sales", this.filter, false)
        const {
          totalRevenue,
          negotiatedProducts,
          ordersPlaced,
          totalMetersUnit,
          averageTicket,
          discountsGranted,
          activeSellers,
          registeredCustomers,
          registeredApplicators,
          status,
          paymentMethods,
          bestSellingProducts,
        } = content
        this.totalRevenue = totalRevenue
        this.negotiatedProducts = negotiatedProducts
        this.ordersPlaced = ordersPlaced
        this.totalMetersUnit = totalMetersUnit
        this.averageTicket = averageTicket
        this.discountsGranted = discountsGranted
        this.activeSellers = activeSellers
        this.registeredCustomers = registeredCustomers
        this.registeredApplicators = registeredApplicators
        this.status = status
        this.paymentMethods = paymentMethods
        this.bestSellingProducts = bestSellingProducts
        this.renderChartOrderByStatus()
        this.renderChartPaymentMethod()
      } catch (e) {

      }
    },
  },

  watch: {},
};
</script>

<style lang='scss' scoped>
#chartRecipeAndOrder {
  width: 100%;
}

#chartPaymentMethod {
  width: 100%;
}

.card-red {
  background: linear-gradient(to bottom, #f54784, #d62828);
  color: #fff;
  width: 100%;
  padding: 5px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: normal;
  }

  p {
    margin: 10px 0 0;
    font-size: 20px;
    font-weight: bold;
  }
}

.card-black {
  background: linear-gradient(to bottom, #000000, #666666);
  color: #fff;
  width: 100%;
  padding: 5px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: normal;
  }

  p {
    margin: 10px 0 0;
    font-size: 20px;
    font-weight: bold;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th, td {
  padding: 10px 15px;
  text-align: left;
}

tr {
  cursor: pointer;
}

th {
  font-weight: bold;
  border-bottom: 2px solid #ddd;
}

/* coluna receita */
td.receita {
  background: linear-gradient(to right, #f8d7da, #f5c6cb);
  text-align: left;
  font-weight: bold;
  color: #333;
}

/* coluna metros */
td.metros {
  background: linear-gradient(to right, #f8d7da, #f1b0b7);
  text-align: left;
  font-weight: bold;
  color: #333;
}

tr:nth-child(even) td {
  background-color: #fafafa;
}

</style>
